import "core-js/modules/es.array.find-index.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "home-ping"
};
var _hoisted_2 = {
  class: "ping-tab"
};
var _hoisted_3 = {
  class: "ping-content"
};
import { ref, computed } from 'vue';
import NavTab from '../Components/NavTab.vue';
import LiSheng from './LiSheng/index.vue';
import Evaluate from './Evaluate/index.vue';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var tabs = [{
      name: '学生评价',
      value: 1,
      component: Evaluate,
      exist: true
    }, {
      name: '组阅卷',
      value: 2,
      component: LiSheng,
      exist: true
    }];
    var defaultIndex = ref(1);
    var currentComponent = computed(function () {
      var index = tabs.findIndex(function (item) {
        return item.value === defaultIndex.value;
      });
      return tabs[index].component;
    });
    var handleChangeTab = function handleChangeTab(item) {
      defaultIndex.value = item.value;
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(NavTab, {
        tabs: tabs,
        "default-index": defaultIndex.value,
        onChange: handleChangeTab
      }, null, 8, ["default-index"])]), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value)))])]);
    };
  }
};